import { Poker2BanditStern } from "./Poker2BanditStern";

/**
 * über jedem rad der slotmaschine und über der grauen abdeckung ein animierter sternenregen
 */

import MovieClip = createjs.MovieClip;

import Event = createjs.Event;

export class Poker2BanditSterne {
    private STERNE_ANZAHL: number = 40;
    private STERNE_ERZEUGEN: number = .4; // alle x%
    private STERNE_ANFANG_STREUUNG: number = 12;
    private STERN_SPEED_ROTATION: number = 8; // drehen um Rad-mitte

    private disp: MovieClip;
    private radNo: number = 0;

    constructor(disp: MovieClip, radNo: number) {
        this.disp = disp;
        this.radNo = radNo;
    }

    /**
     * alles deinstallieren
     */
    public destroy(): void {
        this.sterneStopp();
    }

    /**
     * dreh animation
     */
    public sterneStopp(): void {
        this.disp.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.sterneAnimieren));
        while (this.disp.numChildren > 0) this.disp.removeChildAt(0);
    }

    public sterneStart(): void {
        this.sterneStopp();
        this.disp.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.sterneAnimieren));
    }

    private sterneAnimieren(event: Event): void {
        var stern: Poker2BanditStern;
        var i: number = 0;
        //
        if (this.disp.numChildren < this.STERNE_ANZAHL) {
            if (Math.random() < this.STERNE_ERZEUGEN) {
                stern = new Poker2BanditStern();
                stern.y = this.STERNE_ANFANG_STREUUNG - Math.random() * this.STERNE_ANFANG_STREUUNG * 2;
                stern.x = this.STERNE_ANFANG_STREUUNG - Math.random() * this.STERNE_ANFANG_STREUUNG * 2;
                this.disp.addChild(stern);
            }
        }
        for (i = 0; i < this.disp.numChildren; i++) {
            stern = this.disp.getChildAt(i) as Poker2BanditStern;
            stern.rotation += Math.random() * this.STERN_SPEED_ROTATION;
            stern.animation();
        }
    }

    //
    // static
    //

    /**
     * alle sternen animationen start
     */
    public static allSterneStart(sterne: Poker2BanditSterne[]): void {
        if (sterne) {
            var stern: Poker2BanditSterne;
            for (stern of sterne) {
                stern.sterneStart();
            }
        }
    }

    /**
     * alle sternen animationen stoppen
     */
    public static allSterneStopp(sterne: Poker2BanditSterne[]): void {
        if (sterne) {
            var stern: Poker2BanditSterne;
            for (stern of sterne) {
                stern.sterneStopp();
            }
        }
    }

    //
    // ende
    //
}
